import { render, staticRenderFns } from "./phoneWork.vue?vue&type=template&id=0e4d488c"
import script from "./phoneWork.vue?vue&type=script&lang=ts"
export * from "./phoneWork.vue?vue&type=script&lang=ts"
import style0 from "./phoneWork.vue?vue&type=style&index=0&id=0e4d488c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports